export default __webpack_public_path__ + "static/media/tamGiangSizeClassFrequencies.f26e6bcf.png";